"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingDeterminantsUnits = void 0;
var mean_1 = __importDefault(require("lodash/mean"));
var BillingDeterminantsUnits;
(function (BillingDeterminantsUnits) {
    BillingDeterminantsUnits["KWH"] = "kWh";
    BillingDeterminantsUnits["KW"] = "kW";
    BillingDeterminantsUnits["DAYS"] = "days";
    BillingDeterminantsUnits["MONTHS"] = "months";
    BillingDeterminantsUnits["DOLLARS"] = "dollars";
})(BillingDeterminantsUnits = exports.BillingDeterminantsUnits || (exports.BillingDeterminantsUnits = {}));
var BillingDeterminants = /** @class */ (function () {
    function BillingDeterminants() {
    }
    BillingDeterminants.prototype.mean = function () {
        return mean_1.default(this.calculate());
    };
    BillingDeterminants.prototype.all = function () {
        return this.calculate();
    };
    BillingDeterminants.prototype.map = function (callback) {
        return this.calculate().map(callback);
    };
    return BillingDeterminants;
}());
exports.default = BillingDeterminants;
